export default "__VITE_PUBLIC_ASSET__62bc95ab__"